import { render, staticRenderFns } from "./CheckedItems.vue?vue&type=template&id=67defd10&scoped=true&"
import script from "./CheckedItems.vue?vue&type=script&lang=ts&"
export * from "./CheckedItems.vue?vue&type=script&lang=ts&"
import style0 from "./CheckedItems.vue?vue&type=style&index=0&id=67defd10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67defd10",
  null
  
)

export default component.exports